import type { IcIcon } from "./types";

export const IcExternal: IcIcon = (properties) => (
  <svg height=".5em" viewBox="0 0 7 7" width=".5em" {...properties}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m.5 6.5 6-6M2 .5h4.5V5" />
    </g>
  </svg>
);
